import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreLoginLink as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    useBase64CallBackURL: false,
    useCallbackCookie: false,
    shouldIncludeHash: false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
